import {
  faCheck,
  faClock,
  faComment,
  faEye,
  faTrash,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { updateSubmission } from 'store/Forms/actions'
import ViewSubmissionModal from './ViewSubmissionModal'
import { useSelector } from 'react-redux'
import { deleteSubmission } from 'store/Forms/actions'
import SubmissionLocationsModal from './SubmissionLocationsModal'

const statusLabel = {
  1: 'Not Started',
  2: 'In Progress',
  3: 'Done',
}

const statusIcon = {
  1: faTriangleExclamation,
  2: faClock,
  3: faCheck,
}

const statusIconColor = {
  1: 'text-danger',
  2: 'text-primary',
  3: 'text-success',
}

function Submission({
  submission,
  index,
  setSubmissions,
  lastSubmission,
  hideLocation,
}) {
  const dispatch = useDispatch()
  const [submissionStatus, setSubmissionStatus] = useState(
    submission.status || 1
  )
  const {
    user: { access },
  } = useSelector((store) => store.auth)

  const [showViewSubmissionModal, setShowViewSubmissionModal] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [showLocationsModal, setShowLocationsModal] = useState(false)

  const dropdownRef = useRef(null)

  const handleStatusChange = (status) => {
    dispatch(updateSubmission(submission.id, { status }))
    setSubmissionStatus(status)
    if (dropdownRef.current) {
      dropdownRef.current.toggle()
    }
  }

  const [submissionStoresState, setSubmissionStoresState] = useState(
    submission?.stores || []
  )
  const [submissionStoreIdsState, setSubmissionStoreIdsState] = useState(
    submission?.storeIds || []
  )

  const submissionStores =
    submissionStoresState && submissionStoresState.length
      ? submissionStoresState.join(',')
      : '-'

  return (
    <>
      <div
        key={submission.id}
        className='w-100  d-flex align-items-center justify-content-between px-5 border-bottom'
        style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }}
      >
        <Link
          to={
            access === 1
              ? `manager-reports/employee/${submission.user_id}`
              : '/forms'
          }
          className='flex-item-employee py-3'
        >
          <p>
            {submission.first_name} {submission.last_name}
          </p>
        </Link>
        <DropdownStatus
          changeStatus={handleStatusChange}
          submissionStatus={submissionStatus}
          dropdownRef={dropdownRef}
          lastSubmission={lastSubmission}
        />
        <p className='flex-item-employee py-3'>
          {moment(submission.created_at, 'YYYY-MM-DD HH:mm:ss').format(
            'MM/DD/YYYY'
          )}
        </p>
        {!hideLocation && (
          <div className='flex-item-employee position-relative'>
            <p
              role='button'
              onClick={(e) => {
                if (!showLocationsModal) {
                  setShowLocationsModal(true)
                }
              }}
              title={submissionStores}
              className='py-3 pr-3 submission-store '
            >
              {submissionStores}
              {showLocationsModal && (
                <SubmissionLocationsModal
                  id={submission.id}
                  userId={submission.user_id}
                  setShowLocationsModal={setShowLocationsModal}
                  storeIds={submissionStoreIdsState}
                  setSubmissionStoreIdsState={setSubmissionStoreIdsState}
                  submissionStoreNames={submissionStores}
                  setSubmissionStoresState={setSubmissionStoresState}
                />
              )}
            </p>
          </div>
        )}

        <div className='d-flex align-items-center flex-item-employee py-3'>
          <FontAwesomeIcon
            title='View submission'
            icon={faEye}
            className='submission-icon'
            onClick={() => {
              setShowViewSubmissionModal(true)
              setActiveTab(0)
            }}
          />
          <FontAwesomeIcon
            title='Comments'
            icon={faComment}
            className='mx-3 submission-icon'
            onClick={() => {
              setShowViewSubmissionModal(true)
              setActiveTab(1)
            }}
          />
          <FontAwesomeIcon
            title='Delete submission'
            icon={faTrash}
            className='submission-icon'
            onClick={() => {
              dispatch(deleteSubmission(submission.id))
              setSubmissions((submissions) =>
                submissions.filter((element) => element.id !== submission.id)
              )
            }}
          />
        </div>
      </div>
      {showViewSubmissionModal && (
        <ViewSubmissionModal
          submissionId={submission.id}
          showViewSubmissionModal={showViewSubmissionModal}
          setShowViewSubmissionModal={setShowViewSubmissionModal}
          userId={access === 1 ? submission.user_id : null}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        >
          <DropdownStatus
            changeStatus={handleStatusChange}
            submissionStatus={submissionStatus}
            dropdownRef={dropdownRef}
          />
        </ViewSubmissionModal>
      )}
    </>
  )
}

const Status = ({ submissionStatus }) => {
  return (
    <p
      className={`${statusIconColor[submissionStatus]}`}
      style={{ width: 'fit-content' }}
    >
      <FontAwesomeIcon icon={statusIcon[submissionStatus]} className='' />{' '}
      {statusLabel[submissionStatus]}
    </p>
  )
}

const DropdownStatus = ({
  changeStatus,
  submissionStatus,
  dropdownRef,
  lastSubmission,
}) => {
  return (
    <UncontrolledDropdown
      direction={lastSubmission ? 'up' : 'right'}
      className='flex-item-employee py-3'
      ref={dropdownRef}
    >
      <DropdownToggle
        size='sm'
        tag='p'
        role='button'
        style={{ width: 'fit-content' }}
      >
        <Status submissionStatus={submissionStatus} />
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu-arrow course-dropdown'>
        <div
          role='button'
          className='dropdown-item text-danger'
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => changeStatus(1)}
        >
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            style={{
              marginRight: '10px',
              width: '20px',
              textAlign: 'center',
            }}
          />
          <span>Not Started</span>
        </div>
        <div
          role='button'
          className='dropdown-item text-primary'
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => changeStatus(2)}
        >
          <FontAwesomeIcon
            icon={faClock}
            style={{
              marginRight: '10px',
              width: '20px',
              textAlign: 'center',
            }}
          />
          <span>In Progress</span>
        </div>
        <div
          role='button'
          className='dropdown-item text-success'
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => changeStatus(3)}
        >
          <FontAwesomeIcon
            icon={faCheck}
            style={{
              marginRight: '10px',
              width: '20px',
              textAlign: 'center',
            }}
          />
          <span>Done</span>
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default Submission
